module.exports = __webpack_public_path__ + "static/img/zhanhui-4.eef8b765.png";